import React, { useEffect } from "react";
import UsersRequests from "../../assets/services/user";
import { useDispatch, useSelector } from "react-redux";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import ProfileAvatar from "../../assets/components/ProfileAvatar";
import UpdateUserFields from "./UpdateUserFields";

const UpdateUser = () => {
  const dispatch = useDispatch();
  const { currentUser } = useSelector(({ user }) => user);

  useEffect(() => {
    if (!currentUser?._id) {
      dispatch(UsersRequests.getme());
    }
  }, [currentUser]);

  return (
    <AnimatedPageContainer>
      <div className={"customContainer"}>
        {currentUser ? (
          <>
            <ProfileAvatar showInfo={false} />
            <UpdateUserFields />
          </>
        ) : null}
      </div>
    </AnimatedPageContainer>
  );
};

export default UpdateUser;
